import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MobMaskModule } from '../shared/directives/mob-mask/mob-mask.module';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedToGoBackModule } from '../shared/modules/need-to-go-back/need-to-go-back.module';
import { ProductSearchModule } from '../shared/modules/product-search/product-search.module';
import { LatestOrdersComponent } from './list-orders/latest-orders/latest-orders.component';
import { ListOrdersComponent } from './list-orders/list-orders.component';
import { OldOrdersComponent } from './list-orders/old-orders/old-orders.component';
import { OrderApprovalDtlsComponent } from './order-approval-dtls/order-approval-dtls.component';
import { OrderApprovalComponent } from './order-approval/order-approval.component';
import { OrderDetailsComponent } from './order-details/order-details.component';

@NgModule({
  declarations: [
    ListOrdersComponent,
    OrderDetailsComponent,
    LatestOrdersComponent,
    OldOrdersComponent,
    OrderApprovalComponent,
    OrderApprovalDtlsComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    NgSelectModule,
    FormsModule,
    NgbModule,
    RouterModule,
    MatTabsModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    NeedToGoBackModule,
    FluDashboardBannerModule,
    ProductSearchModule,
    ReactiveFormsModule,
    MobMaskModule,
    MatProgressSpinner,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountOrderHistoryComponent: {
          component: () =>
            import('./list-orders/list-orders.component').then(
              (m) => ListOrdersComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderDetailsOverviewComponent: {
          component: () =>
            import('./order-details/order-details.component').then(
              (m) => m.OrderDetailsComponent
            ),
          guards: [AuthGuard],
        },
        OrderHistoryBannerComponent: {
          component: () =>
            import('./list-orders/list-orders.component').then(
              (m) => m.ListOrdersComponent
            ),
        },
        AccountOrderApprovalDashboardComponent: {
          component: () =>
            import('./order-approval/order-approval.component').then(
              (m) => m.OrderApprovalComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderApprovalDetailsOverviewComponent: {
          component: () =>
            import('./order-approval-dtls/order-approval-dtls.component').then(
              (m) => m.OrderApprovalDtlsComponent
            ),
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
  ],
})
export class OrderHistoryModule {}
